'use strict';

var valueIsNotInfinite = require('./valueIsNotInfinite'),
    getRangeMemberPrimitiveValue = require('./getRangeMemberPrimitiveValue');

function isValidRangeMember(m) {
  var val = getRangeMemberPrimitiveValue(m);
  return (!!val || val === 0) && valueIsNotInfinite(m);
}

module.exports = isValidRangeMember;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar-date/range/internal/isValidRangeMember.js
// module id = 399
// module chunks = 1